
var React = require("react");

class UploadFileButton extends React.Component  {
    constructor(){
        super()

        this.handleWindowFile = this.handleWindowFile.bind(this);
        this.onUpload = this.onUpload.bind(this);
    }

    handleWindowFile(){
        this.importFile.click();
        if(this.props.onClick){
            this.props.onClick();
        }
    }

    onUpload(){
        this.props.onUpload(this.importFile.files);
        this.importFile.value = "";
    }

    render(){
        const { 
            text = "", 
            style = {},
            accept = "", 
            addedClass = "",
            multiple = false,
            webkitdirectory = false,
            disabled = false
        } = this.props;

        return (
            <button
                style={style}
                className={`button ${addedClass}`}
                disabled={disabled}
                onClick={this.handleWindowFile}>
                    <p>{text}</p>
                    <input id="import__file" type="file"
                           multiple={multiple}
                           accept={accept}
                           ref={input => this.importFile = input} 
                           hidden 
                           onChange={this.onUpload}
                           {...(webkitdirectory ? { webkitdirectory: "true" } : {})}
                    />
            </button> 
        );
    }
}

module.exports = UploadFileButton;